<template>
  <div class="simditor">
    <textarea
      :id="id"
      :placeholder="placeholder"
      contenteditable="false"
    ></textarea>
  </div>
</template>
<script>
import $ from "jquery";
import Simditor from "simditor";
import "simditor/styles/simditor.css";
export default {
  name: "simditor",
  data() {
    return {
      editor: "",
    };
  },
  props: {
    id: "", //这里传入动态id，一个页面能使用多个编辑器
    options: {
      //配置参数
      type: Object,
      default() {
        return {};
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
  },
  watch: {
    disabled(n) {
      this.disabledInput(n);
    },
  },
  mounted() {
    this.$emit("update:id", this.id + "1");
    let vm = this;
    this.editor = new Simditor(
      Object.assign(
        {},
        {
          textarea: $(`#${vm.id}`),
        },
        this.options
      )
    );
    this.editor.on("valuechanged", (e, src) => {
      this.valueChange(e, src);
    });
    this.editor.on("focus", (e, src) => {
      this.focus(e, src);
    });
    this.editor.on("blur", (e, src) => {
      this.blur(e, src);
    });
    if (this.disabled) {
      this.disabledInput(this.disabled);
    }
  },
  methods: {
    setVal(val){
      this.editor.setValue(val)
    },
    disabledInput(n) {
      let contentEditable = document.getElementsByClassName("simditor-body");
      for (let i = 0; i < contentEditable.length; i++) {
        contentEditable[i].contentEditable = !n;
      }
    },
    valueChange(e, val) {
      this.$emit("change", this.editor.getValue());
    },
    focus(e, val) {
      this.$emit("focus", this.editor.getValue());
    },
    blur(e, val) {
      this.$emit("blur", this.editor.getValue());
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>